export default ({ pageState: { editorBlocks }, data: { visibility } }) => {
  const modifiedBlocks = { ...editorBlocks };
  for (const blockId of Object.keys(editorBlocks)) {
    const block = editorBlocks[blockId];
    if (
      block.isSelected ||
      visibility === block.data.visibility ||
      (visibility !== 'hidden' && block.data.visibility !== 'hidden')
    ) {
      modifiedBlocks[blockId] = { ...block, isSelected: true };
    }
  }

  return { editorBlocks: modifiedBlocks };
};
